import axios from 'axios';
import swal from 'sweetalert2';// import sweet alert

const fireMessage = (title, text, icon) => {
    return swal.fire({
        title,
        text,
        icon,
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (result.isConfirmed || result.value) { // value for older SweetAlert2
            window.location.href = '/';
        }
    });
};

const state = {
    user: {},
    accessToken: localStorage.getItem('access_token') || null,
    userId: null,
    menus: [],
    dashbardInfo: {},
    lastFetch: 0,
    preferredMethod: localStorage.getItem('method') || null
};
 
const getters = { 
    user: state => state.user,    
    getUserAccessToken: state => state.accessToken,
    getPreferredMethod: state => state.preferredMethod,
    isLoggedIn: state => state.accessToken != null ? true : false,
    menus: state => state.menus,
    dashbardInfo: state => state.dashbardInfo,
    shouldUpdate: (state) => {
        const lastFetch = state.lastFetch;
        if (!lastFetch) return true; // Always fetch if never fetched
        const fiveMinutes = 5 * 60 * 1000;
        return (Date.now() - lastFetch) > fiveMinutes;
    }
};

const actions = {
    async updateAdminProfile({ state, getters, rootState, commit }, status = false) {// fetch profile only not cached 
        if (!getters.shouldUpdate && ! status) {
            // console.log("Using cached products.");
            return state.user; // Exit early if the cache is still fresh
        }
        // console.log("updating from server");
        try {
            const authorizationToken = rootState.url.authorizationToken;
            const url = rootState.url.profileUserUrl;  
            const header = {Authorization: `Bearer ${authorizationToken}`}; 
            const response = await axios.post(url, {}, { headers: header });// make api call 
            commit('setMenus', response.data.menus);
            commit('setUser', response.data.user);
            commit('setDashbardInfo', response.data.dashboard);
            return response.data.user;
        } catch (error) {     
            fireMessage(
                "Session Expired!", 
                "Your session has expired please log in again to continue", 
                "warning"
            );       
            localStorage.removeItem('access_token');// remove token
            localStorage.removeItem('time_out');// remove time out
            state.accessToken = null;
            setTimeout(() => { window.location.href = '/'; }, 5000);// redirect to login
        }
    },
    async fetchUserProfile(state) {// fetch user profile
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.profileUserUrl;  
        const header = {Authorization: `Bearer ${authorizationToken}`}; 
        const response = await axios.post(url, {}, 
                { headers: header });// make api call 
        state.commit('setMenus', response.data.menus);
        state.commit('setUser', response.data.user);
        return response.data.user;
    },
    destroyAccessToken(state) {// destroy local storage        
        localStorage.removeItem('access_token');// remove token
        localStorage.removeItem('time_out');// remove time out
        state.accessToken = null;  
        fireMessage(
            "Session Ended!", 
            "You have been logged out...", 
            "warning"
        );      
        return setTimeout(() => { window.location.href = '/'; }, 5000); // redirect to login page 
    },
    storeAndLoginUser(state, data) {//set token and login user
        let hours = 1;
        localStorage.setItem('access_token', data.access_token);// set access token 
        localStorage.setItem('method', data.preferred_method);// set access token
        localStorage.setItem('time_out', new Date().getTime() + (hours * 60 * 60 * 1000));// set timeout
    },
    async changePassword(state, data) {// get user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.changePasswordUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`}; 
        let response = await axios.post(url, {data}, { headers: header});// make api call
        return response.data;        
    },
    async resetAdminPassword(state, data) {// get user additional records
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.resetAdminPasswordUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`}; 
        let response = await axios.post(url, data, { headers: header});// make api call
        return response.data;        
    }
};

const mutations = {
    setMenus: (state, menus) => (state.menus = menus),// set menus only
    setUser(state, user) {
        state.user = user;// set user profile
        state.userId = user.id;
        state.lastFetch = Date.now(); // Update the timestamp
    }, 
    setDashbardInfo: (state, data) => (state.dashbardInfo = data)// set Dashbard Info
};

export default {
    state,
    getters,
    actions,
    mutations
}